import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './index.css';
import { useTranslation } from 'react-i18next';
import TrafficDiagram from './components/TrafficDiagram';
import Navbar from './components/navbar/NavBar';
import Home from './components/Home';
import ContactUs from './components/ContactUs';
import Jobs from './components/Jobs';
import AboutUs from './components/AboutUs';
import OurServices from './components/OurServices';
import Footer from './components/Footer';
import TrafficJams from './components/TrafficJams';
import TripsDashboard from './components/trips/TripsDashboard';
import AppLayout from './components/navbar/AppLayout';
import Users from './components/users/Users';
import DriversMap from './components/driversMap/DriversMap';
import "keen-slider/keen-slider.min.css";
import "leaflet/dist/leaflet.css";

export default function App() {
  const { t, i18n } = useTranslation();

  // عند بداية التحميل، قم بتعيين اتجاه الصفحة بناءً على اللغة
  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' || i18n.language === 'he' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div style={{ padding: 20 }} >
      <AppLayout t={t} i18n={i18n}>
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/TrafficJams" element={<TrafficJams />} />
          <Route path="/Trips" element={<TripsDashboard />} />
          <Route path="/About" element={<AboutUs />} />
          <Route path="/Services" element={<OurServices />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/Jobs" element={<Jobs />} />
          <Route path="/Users" element={<Users />} />
          <Route path="/DriversMap" element={<DriversMap />} />
        </Routes>
      </AppLayout>
      <Footer />
    </div >
  );
}
